<script setup>

defineBuilderComponent({
    friendlyName: 'Content_Section_6',
    ignored: true
})
</script>


<template>
  <section class="pb-20 bg-indonesia">
    <div class="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 sm:py-8 lg:px-6">
      <!-- Row -->

      <div class="max-w-screen-xl px-4 py-8 mx-auto text-center sm:py-16 lg:px-6">
        <h2 class="mb-4 font-extrabold h2 "> Uncover the Story Behind Rony Lavan's Peruvian Microlot Coffee and Join a Legacy of Conscious Coffee Lovers</h2>
        <p class="h4  !mt-4">As you indulge in the captivating flavors and aromas of Rony Lavan's Peruvian microlot coffee, you're not just experiencing a remarkable beverage; you're becoming a part of a greater narrative.</p>

      </div>




      <div class="gap-8 items-center !mt-6 grid lg:grid-cols-2 xl:gap-16 md-max:max-w-lg md-max:m-auto">
        <div class="sm:text-lg  md-max:order-[2]">



          <ul class="space-y-4">
            <li class="flex space-x-3">


              <span class="textp -mt-0.5">


             By choosing this exquisite coffee, you're supporting fair trade practices, sustainable farming, and the tireless efforts of passionate farmers like Rony Lavan, who work diligently to bring you the very best of Peru's coffee scene.


              </span></li>


            <li class="flex space-x-3">


              <span class="textp -mt-0.5">


           Embrace the opportunity to make a difference and embark on a sensory journey that transcends the ordinary. Let the captivating essence of the Andean highlands and the inspiring story of Rony Lavan's farm resonate within you each time you enjoy a cup of this exceptional coffee.


              </span></li>

            <li class="flex space-x-3">


              <span class="textp -mt-0.5">


        Don't hesitate! Click the <a @click="scrollTo('the-products')" class="font-bold cursor-pointer">"Order Now"</a> button and join us in celebrating the enchanting world of traceable Peruvian microlots, where quality, fairness, and sustainability come together in perfect harmony.


              </span></li>

          </ul>

          <button
              @click="scrollTo('the-products')"
              class="items-center mt-10 justify-center uppercase text-sm lg:text-lg hover:shadow-lg text-center sm:w-auto w-full font-ginger leading-4 bg-lifeboost-red text-white hover:opacity-80 rounded-full py-3.5 xl:py-4 px-7 xl:px-9 transition-all"> Order now </button>


        </div>
        <nuxt-img class="object-cover w-full h-full mb-4 rounded-lg lg:mb-0 lg:flex"
                  src="/assets/images/image9.jpg"
                  width="584"
                  height="387"
                  loading="lazy"
                  format="webp"
                  sizes="sm:440px md:600px lg:720px xl:584px"
                  alt="cajamarca Story Behind Rony Lavan's Peruvian Microlot Coffee"/>

      </div>
      <!-- Row -->

    </div>
  </section>
</template>

<style scoped></style>
